<template>
  <div class="left-list">
    <h3>用戶中心</h3>
    <ul>
      <router-link tag="li" :to="{name: 'buyMaterial'}">
        <span>已购素材</span>
      </router-link>
      <router-link tag="li" :to="{name: 'smallRecord'}">
        <span>小样记录</span>
      </router-link>
      <router-link tag="li" :to="{name: 'browseRecord'}">
        <span>浏览记录</span>
      </router-link>
      <router-link tag="li" :to="{name: 'myCollection'}">
        <span>我的收藏</span>
      </router-link>
    </ul>
  </div>
</template>
<script>
export default {
    name: 'sidebar',
    data() {
        return {}
    }
}
</script>
<style scoped>
  .main-content .left-list{
    width: 161px;
    padding: 40px;
    background: #fff;
    align-self: baseline;
  }
  .main-content .left-list h3{font-size:20px;text-align: left;margin-bottom: 25px;}
  .main-content .left-list ul{
    display: flex;
    flex-direction: column;
  }
  .main-content .left-list ul li{
    position: relative;
    padding-left:17px;
    margin: 15px 0;
    cursor: pointer;
  }
  .main-content .left-list ul li.router-link-active{
    font-weight: bold;
  }
  .main-content .left-list ul li.router-link-active:before{
    content:"";
    position: absolute;
    display: inline-block;
    width:4px;
    height:20px;
    background: #ff9f00;
    left:0;
    top:50%;
    margin-top:-10px;
  }
</style>